import { useState } from 'react'
import styled from 'styled-components'

import {
  palette,
  fonts,
  mediaQueries,
  setOpacity,
} from '../../styles/variables'
import { translate } from '../../utils/translation'
import GoogleSignIn from '../buttons/GoogleSignIn'
import { isSignedIn } from '../../utils/userAuth'
import { CloseButton } from '../buttons/Buttons'
import noDataBg_en from '../../styles/assets/nodata/nodata_en.png'
import noDataBg_de from '../../styles/assets/nodata/nodata_de.png'
import noDataBg_es from '../../styles/assets/nodata/nodata_es.png'
import noDataBg_fr from '../../styles/assets/nodata/nodata_fr.png'
import noDataBg_it from '../../styles/assets/nodata/nodata_it.png'
import noDataBg_ja from '../../styles/assets/nodata/nodata_ja.png'
import noDataBg_nl from '../../styles/assets/nodata/nodata_nl.png'
import noDataBg_pt from '../../styles/assets/nodata/nodata_pt.png'
import noDataBg_zh from '../../styles/assets/nodata/nodata_zh.png'
import { Text } from '../topography'

import Modal, { ModalContent, RowContent } from './Modal'

const noDataBg = {
  en: noDataBg_en,
  de: noDataBg_de,
  es: noDataBg_es,
  fr: noDataBg_fr,
  it: noDataBg_it,
  ja: noDataBg_ja,
  nl: noDataBg_nl,
  pt: noDataBg_pt,
  zh: noDataBg_zh,
}

const desktopStyle = {
  width: '943px',
  cornerRound: '3px',
  overflow: 'visible',
}

const mobileStyle = {
  width: '90%',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
}

const InputField = styled.input({
  fontSize: '15px',
  width: '365px',
  height: '60px',
  marginBottom: '24px',
  backgroundColor: palette.orange70,
  color: palette.white,
  borderRadius: '2px',
  border: 'none',
  fontFamily: fonts.primaryLight,
  '::placeholder': {
    color: setOpacity(palette.white, 0.5),
    fontWeight: '100',
  },
})

const Content = styled(RowContent)({
  alignItems: 'flex-start',
})

const Column = styled.div(({ justifyContent = 'flex-start' }) => ({
  display: 'flex',
  flex: 1,
  width: '50%',
  height: '100%',
  flexDirection: 'column',
  justifyContent,
  position: 'relative',
  [mediaQueries.mobile]: {
    width: '100%',
  },
}))

const Wrapper = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: props.textAlign || 'flex-start',
  backgroundColor: props.backgroundColor || palette.orange,
  padding: '30px 40px',
  '& input': {
    textAlign: 'center',
  },
}))

const List = styled.ul({
  padding: 0,
  width: '100%',
  margin: '0',
  listStyle: 'disc',
})

const Item = styled.li({
  margin: '0px 0 0px 14px',
  lineHeight: '30px',
  fontSize: '15px',
  fontFamily: fonts.primaryLight,
  color: palette.white,
})

export default ({ onClose, isOpen, lang, ...rest }) => {
  const [domain, setDomain] = useState('')
  const loggedIn = isSignedIn()

  return (
    <Modal
      isOpen={isOpen}
      desktopStyle={desktopStyle}
      mobileStyle={mobileStyle}
      parentSelector={() => document.getElementById('prompt-modal-global')}
      {...rest}
    >
      <ModalContent style={{ height: 'fit-content', padding: '0' }}>
        <Content>
          <Column>
            <img
              src={noDataBg[lang]}
              alt="No Data bg"
              style={{
                position: 'absolute',
                top: '55px',
                right: '0px',
              }}
              width={536}
              height={444}
            />
          </Column>
          <Column>
            <CloseButton
              color={palette.white}
              onClick={onClose}
              styles={{
                position: 'absolute',
                top: 20,
                right: 20,
              }}
            />
            <Wrapper>
              <Text
                fontSize={lang === 'ja' || lang === 'de' ? '26px' : '30px'}
                fontFamily={fonts.primaryMedium}
                margin="30px 0 0 0"
                lineHeight="58px"
                color={palette.white}
              >
                {loggedIn
                  ? translate('new_exit2_heading')
                  : translate('new_exit1_heading')}
              </Text>
              <Text
                fontFamily={fonts.primaryLight}
                fontSize="17px"
                lineHeight="22px"
                color={palette.white}
                boldColor={palette.white}
                margin="0px 0 20px 0"
                dangerouslySetInnerHTML={{
                  __html: loggedIn
                    ? translate('new_exit2_subheading')
                    : translate('new_exit1_subheading'),
                }}
              />
              <List>
                <Item>{translate('bullet_track_rankings', 200)}</Item>
                <Item>{translate('bullet_identify_issues')}</Item>
                <Item>{translate('bullet_get_alerts')}</Item>
              </List>
            </Wrapper>
            <Wrapper backgroundColor={palette.orange} textAlign="center">
              <Text
                fontSize="15px"
                lineHeight="36px"
                color={palette.white}
                boldColor={palette.white}
                dangerouslySetInnerHTML={{
                  __html: translate('new_exit_footer'),
                }}
              />
              <InputField
                name="domain"
                value={domain}
                isValid
                placeholder={translate('new_exit_url')}
                onChange={(e) => setDomain(e.target.value)}
              />
              <GoogleSignIn
                hideIcon
                redirectURL={`/${lang}/dashboard?action=add_project&domain=${domain}`}
                label={translate('get_started')}
                height="42px"
                minWidth="fit-content"
                theme="dark"
                mobileStretch
                style={{
                  marginBottom: '10px',
                }}
              />
            </Wrapper>
          </Column>
        </Content>
      </ModalContent>
    </Modal>
  )
}
